module.exports = __webpack_public_path__ + "assets/pipe-fitter.svg?3a41f3d651cd3811737313fd02e69268";